import React from "react";
import { FooterContact } from "./utils/contactFooter";
import { HamburgerMenu } from "./utils/hamburger";
import { DesktopNav } from "./utils/dekstopNav";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <>
      <HamburgerMenu />
      <DesktopNav />
      <main>{children}</main>
      <FooterContact />
    </>
  );
};
